/**
 * Builds the notification WebSocket URL from the same API base used for REST (withCredentials cookies).
 * http:// → ws:// , https:// → wss:// , path /ws/notifications/
 */
export function buildNotificationsWebSocketUrlFromApiHost(apiUrlHost: string): string {
  const base = apiUrlHost.trim().replace(/\/+$/, '');
  const wsOrigin = base.replace(/^http:\/\//i, 'ws://').replace(/^https:\/\//i, 'wss://');
  return `${wsOrigin}/ws/notifications/`;
}
